const { CHANNEL_INTERFACE_TYPE } = require('@/enums');
const { getChannelOptionsWithPutInManage } = require('@/tools');

module.exports = (s) => {
  return {
    channel_interface: {
      label: '媒体平台',
      type: 'select',
      props: {
        clearable: false,
        placeholder: '请选择媒体平台',
      },
      options: getChannelOptionsWithPutInManage(),
      value: CHANNEL_INTERFACE_TYPE.JRTT,
      on: {
        change: async() => {
          const { channel_interface, advertiser_id, filtering: { children: { campaign_id }}} = s.table_filter;
          advertiser_id.value = '';
          campaign_id.value = '';
          advertiser_id.options = channel_interface.value ? await s.getAdvertiserList(channel_interface.value) : [];
        },
      },
    },
    advertiser_id: {
      label: '广告主账户',
      type: 'select',
      options: [],
      value: '',
      on: {
        change: async() => {
          const { channel_interface, advertiser_id, filtering: { children: { campaign_id }}} = s.table_filter;
          campaign_id.value = '';
          campaign_id.options = await s.getCampaignSelector({ channel_interface: channel_interface.value, advertiser_id: advertiser_id.value });
        },
      },
      rules: { required: true, message: '请选择广告主账户', trigger: 'change' },
    },
    filtering: {
      value: {},
      children: {
        campaign_id: {
          label: '广告',
          type: 'select',
          props: {
            filterable: true,
          },
          options: [],
          value: '',
        },
        creative_name: {
          label: '创意名称',
          type: 'input',
          props: {
            placeholder: '请输入创意名称',
          },
          value: '',
        },
      },
    },
  };
};

